(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("RevWebflow", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["RevWebflow"] = factory(require("react"), require("react-dom"));
	else
		root["RevWebflow"] = factory(root["React"], root["ReactDOM"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__442__, __WEBPACK_EXTERNAL_MODULE__3__) => {
return 